import React from 'react';
import { defaultTemplate } from 'core/hoc';
import BasicRadio from 'themes/components/forms/BasicRadio';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import _ from 'lodash';

const AddressValidationTemplate = ({
	t,
	form,
	viewStore: {
		onValidateAddressBack,
		onToggleAddress,
		enteredAddress,
		updatedAddress,
		onValidateAddressConfirm,
		useEnteredAddress,
	},
}) => {
	return (
		<div>
			<div>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.EDITMODAL.ADDRESSVALIDATION')}</h3>
				</div>
				<div className="ReactModal__body">
					<ButtonGroup className="k-button-group--validation">
						<Button togglable={true} selected={useEnteredAddress} onClick={() => onToggleAddress(true)} type="button">
							<div>
								<h6>{t('FULFILLMENTORDER.EDITMODAL.ENTEREDADDRESS')}</h6>
								{enteredAddress.streetLines.map((streetLine, index) => {
									return streetLine ? <p key={index}>{streetLine}</p> : null;
								})}
								<p>{enteredAddress.city}</p>
								<p>
									{enteredAddress.postalCode} {form.$('shippingCoreCountryState').value.label}
								</p>
								<p>{form.$('shippingCoreCountry').value.label}</p>
							</div>
							<BasicRadio
								field={form.$('useEnteredAddress')}
								value={useEnteredAddress}
								name="useEnteredAddress"
								label=""
								className="input--radio"
							></BasicRadio>
						</Button>

						<Button togglable={true} selected={!useEnteredAddress} onClick={() => onToggleAddress(false)} type="button">
							<div>
								<h6>{t('FULFILLMENTORDER.EDITMODAL.UPDATEDADDRESS')}</h6>
								{updatedAddress.streetLines.map((streetLine, index) => {
									return streetLine ? <p key={index}>{streetLine}</p> : null;
								})}
								<p>{updatedAddress.city}</p>
								<p>
									{updatedAddress.postalCode} {form.$('shippingCoreCountryState').value.label}
								</p>
								<p>{form.$('shippingCoreCountry').value.label}</p>
							</div>
							<BasicRadio
								field={form.$('useUpdatedAddress')}
								value={!useEnteredAddress}
								label=""
								name="useUpdatedAddress"
								className="input--radio"
							></BasicRadio>
						</Button>
					</ButtonGroup>
				</div>
			</div>

			<div className="ReactModal__footer">
				<button
					className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
					type="button"
					onClick={() => onValidateAddressConfirm()}
				>
					{t('FULFILLMENTORDER.EDITMODAL.CONFIRM')}
				</button>
				<button
					className="btn btn--med btn--secondary spc--bottom--sml"
					type="button"
					onClick={() => onValidateAddressBack()}
				>
					{t('FULFILLMENTORDER.EDITMODAL.BACK')}
				</button>
			</div>
		</div>
	);
};

export default defaultTemplate(AddressValidationTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/AddressValidationTemplate.jsx